import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {CollapseModule} from 'ngx-bootstrap/collapse'
import {DateFilterComponent} from './date-filter.component'
import {NgxDaterangepickerBootstrapModule} from 'ngx-daterangepicker-bootstrap'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CollapseModule,
    FormsModule,
    NgxDaterangepickerBootstrapModule,
  ],
  declarations: [DateFilterComponent],
  exports: [DateFilterComponent],
})
export class DateFilterModule {}
